import Headline3 from "components/elements/Headline3"

const NoBrandData = (props) => {
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            width: '100%',
        }}>
            <Headline3
                translationKey={'_BRAND_NOT_FOUND_ERROR_MESSAGE_'}
                fallbackText={'Vi kunne ikke finde den klub du ledte efter!'}
            />
        </div>
    )
}

export default NoBrandData

